// extracted by mini-css-extract-plugin
export default {"root":"StatusCell_root__g3WHx","marker":"StatusCell_marker__CIOsK"};